import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import authSlice from './slices/authSlice';
import vanchiSlice from './slices/vanchiSlice';
import usersSlice from './slices/usersSlice';
import mastersSlice from './slices/mastersSlice';
import vanchiNoSlice from './slices/vanchiNoSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    vanchi: vanchiSlice,
    users: usersSlice,
    masters: mastersSlice,
    vanchiNo: vanchiNoSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
